import React from "react";
import Drawer from "../Drawer/Drawer";
import UserRestrictions from "./UserRestrictions";


const ModalUserRestrictions = ({
        toggle = false,
        handleClose = () =>{},
        isModal = false,
        userId = "",
        username = ""
    }) => {
    return isModal ? (
        <Drawer
            large
            open={toggle}
            handleClose={handleClose}
            headContent="Messages de modération"
        >
            <UserRestrictions
                toggle={toggle}
                handleClose={handleClose}
                userId={userId}
                username={username}
            />
        </Drawer>
    ) : (
        <UserRestrictions
            toggle={toggle}
            handleClose={handleClose}
            userId={userId}
            username={username}
        />
    )
}

export default ModalUserRestrictions;